export const environment = {
  production: true,
  buildId: '2753267909518811',
  configFile: 'config.json',
};
